var style = document.createElement("style");
style.setAttribute("less", "responsive-child.less");
style.innerHTML = "[is=responsive-child],\nresponsive-child {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n";
document.head.appendChild(style);
